var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseBadge',{class:{
      'bg-red' : _vm.status === 0,
      'bg-yellow' : _vm.status === 1,
      'bg-green' : _vm.status === 2,
      'bg-text-ternary' : _vm.status === 3
    }},[_vm._v(" "+_vm._s(_vm.ticketStatus.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }